// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__31UTv","footer":"ModalInfo_footer__vpWMd"};